import React from 'react';
import { Link } from 'react-router-dom';
import '../../../styles/components/landing/LandingFooter.css';

const LandingFooter = () => {
  const currentYear = new Date().getFullYear();

  const handleContactClick = () => {
    // Handle contact functionality
    console.log('Contact clicked');
  };

  const handleSocialClick = (platform) => {
    // Handle social media links
    console.log(`${platform} clicked`);
  };

  return (
    <footer className="landing-footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="brand-icon">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <circle cx="16" cy="16" r="14" stroke="#4CAF50" strokeWidth="2"/>
                  <path d="M11 16h10M16 11v10" stroke="#4CAF50" strokeWidth="2"/>
                </svg>
              </div>
              <span className="brand-text">NEUROLEX</span>
            </div>
            <p className="footer-description">
              Empowering mental health through AI-powered solutions. 
              Professional assessment, monitoring, and personalized care.
            </p>
            <div className="social-links">
              <button 
                onClick={() => handleSocialClick('facebook')}
                className="social-link"
                aria-label="Facebook"
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M20 10C20 4.477 15.523 0 10 0S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z" fill="currentColor"/>
                </svg>
              </button>
              <button 
                onClick={() => handleSocialClick('twitter')}
                className="social-link"
                aria-label="Twitter"
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" fill="currentColor"/>
                </svg>
              </button>
              <button 
                onClick={() => handleSocialClick('linkedin')}
                className="social-link"
                aria-label="LinkedIn"
              >
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M18.521 0H1.475C.66 0 0 .645 0 1.44v17.12C0 19.355.66 20 1.475 20h17.042C19.336 20 20 19.355 20 18.56V1.44C20 .645 19.336 0 18.521 0zM5.928 17.058H2.946V7.508h2.982v9.55zM4.437 6.208a1.732 1.732 0 110-3.464 1.732 1.732 0 010 3.464zM17.062 17.058h-2.979v-4.64c0-1.106-.02-2.53-1.544-2.53-1.544 0-1.781 1.207-1.781 2.452v4.718H7.773V7.508h2.857v1.305h.041c.397-.754 1.369-1.544 2.821-1.544 3.018 0 3.574 1.985 3.574 4.567v5.222h-.004z" fill="currentColor"/>
                </svg>
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="link-list">
              <li><Link to="/how-it-works" className="footer-link">How It Works</Link></li>
              <li><Link to="/for-professionals" className="footer-link">For Professionals</Link></li>
              <li><Link to="/for-clinics" className="footer-link">For Clinics</Link></li>
              <li><Link to="/partner-clinics" className="footer-link">Our Partner Clinics</Link></li>
            </ul>
          </div>

          {/* Legal Links */}
          <div className="footer-links">
            <h4 className="footer-title">Legal</h4>
            <ul className="link-list">
              <li><Link to="/privacy" className="footer-link">Privacy Policy</Link></li>
              <li><Link to="/terms" className="footer-link">Terms of Service</Link></li>
              <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h4 className="footer-title">Get in Touch</h4>
            <div className="contact-info">
              <div className="contact-item">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M2.667 2.667h10.666c.734 0 1.334.6 1.334 1.333v8c0 .733-.6 1.333-1.334 1.333H2.667c-.734 0-1.334-.6-1.334-1.333V4c0-.733.6-1.333 1.334-1.333z" stroke="currentColor" strokeWidth="1.333" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M14.667 4L8 8.667 1.333 4" stroke="currentColor" strokeWidth="1.333" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>support@neurolex.com</span>
              </div>
              <div className="contact-item">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M14.667 11.28v1.387a.933.933 0 01-1.02.933c-1.386-.06-2.72-.48-3.886-1.226a9.61 9.61 0 01-2.708-2.708c-.747-1.167-1.167-2.5-1.227-3.887a.933.933 0 01.933-1.02h1.387a.933.933 0 01.933.8c.06.453.171.898.333 1.327a.933.933 0 01-.21.986l-.587.587a7.467 7.467 0 002.708 2.708l.587-.587a.933.933 0 01.986-.21c.429.162.874.273 1.327.333a.933.933 0 01.8.933v0z" stroke="currentColor" strokeWidth="1.333" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>+1 (555) 123-4567</span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; {currentYear} NEUROLEX. All rights reserved.</p>
          </div>
          <div className="footer-meta">
            <span>Made with ❤️ for better mental health</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;